import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import '../../DocumentReport.css';

class ThirteenFLongPosReportChkResultGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.thirteenFLongPosReportChkResultGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 100,
        sortable: true,
        filter: true,
        resizable: true,
      },
      rowSelection: "multiple",
    };
  }

  getRowNodeId = data => {
    return data.id;
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    this.gridApi.closeToolPanel();

    // const COLUMNS_KEY = 'fund-list-grid-col-state';

    // StateSynchronizer.syncGrid(
    //   params,
    //   this.state.columnDefs,
    //   () => localStorageClient.getGridColumnState(COLUMNS_KEY),
    //   s => localStorageClient.saveGridColumnState(COLUMNS_KEY, s)
    // );
  };

  render() {
    const {
      thirteenFLongPosReportChkResult,
      className = 'grid-wrapper',
      // Load 13F Long Report Check Result
      loadThirteenFLongPosReportCheckResultActionStatus,
    } = this.props;

    const isLoading = loadThirteenFLongPosReportCheckResultActionStatus === ACTION_STATUS.LOGINING;
    if (loadThirteenFLongPosReportCheckResultActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadThirteenFLongPosReportCheckResultActionStatus();
    }

    return (
      <div className={`ag-theme-balham ${className}`}>
        {isLoading ? (
          <Loader active content="Loading..." />
        ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={thirteenFLongPosReportChkResult}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            animateRows={true}
            immutableData={false}
            resizable={true}
            sideBar={true}
            getRowNodeId={this.getRowNodeId}
            // events
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default ThirteenFLongPosReportChkResultGrid;